import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import styles from 'src/styles/common.module.scss'

export const TextContentDe = () => {
    return (
        <HighlightedText
            text="HOLEN SIE SICH IHREN BONUS 325% Einzahlungsbonus + 400 FREISPIELE"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['SICH', '325%', '+']}
            className={styles.text_content}
        />
    )
}
